module.exports = __webpack_public_path__ + "static/media/productivity-graph.b1935476.png";